const ProcessTypes = {
  Posting: "posting",
  Normal: "normal",
  Grid: "grid",
  Business: "business",
  Cycle: "cycle",
};
Object.freeze(ProcessTypes);

const BlueZoneItemTypes = {
  Style: "style",
  File: "file",
  Edit: "edit",
  View: "view",
  Util: "util",
  Insert: "insert",
  Settings: "settings",
};

Object.freeze(BlueZoneItemTypes);

const ProcessItemTypes = {
  ...ProcessTypes,
  Folder: "folder",
  Private: "private",
  SAP: "sap",
  Team: "team",
  Trash: "trash",
  Player: "player",
  Sheet: "sheet",
};
Object.freeze(ProcessItemTypes);

const TeamTypes = {
  Team: "team_folder",
  Owner: "owner",
  Viewer: "viewer",
  Comment: "comment",
  Manage: "manage",
  Admin: "admin",
  Editor: "editor",
};
Object.freeze(TeamTypes);

const ToolTypes = {
  Settings: "settings",
  Tools: "tools",
};
Object.freeze(ToolTypes);

const icons = {
  [ProcessItemTypes.Posting]: "icon-posting_process",
  [ProcessItemTypes.Normal]: "icon-process",
  [ProcessItemTypes.Business]: "icon-finance",
  [ProcessItemTypes.Grid]: "icon-grid-large",
  [ProcessItemTypes.Folder]: "icon-folder",
  [ProcessItemTypes.Trash]: "icon-trash",
  [ProcessItemTypes.Team]: "icon-users",
  [ProcessItemTypes.Private]: "icon-user",
  [ProcessItemTypes.Player]: "icon-game_character_C",
  [ProcessItemTypes.SAP]: "icon-finance",
  [ProcessItemTypes.Cycle]: "icon-finance",
  [BlueZoneItemTypes.File]: "icon-File",
  [BlueZoneItemTypes.Insert]: "icon-Insert",
  [BlueZoneItemTypes.Edit]: "icon-Edit",
  [BlueZoneItemTypes.Util]: "icon-Tools",
  [BlueZoneItemTypes.View]: "icon-View",
  [BlueZoneItemTypes.Settings]: "icon-settings",
  [BlueZoneItemTypes.Style]: "icon-palette-outline",
  [TeamTypes.Team]: "icon-folder",
  [TeamTypes.Viewer]: "icon-user_viewer",
  [TeamTypes.Editor]: "icon-user_editor",
  [TeamTypes.Admin]: "icon-user_admin",
  [TeamTypes.Owner]: "icon-user_owner_A",
  [TeamTypes.Comment]: "icon-comment-edit-outline",
  [TeamTypes.Manage]: "icon-share-2",
  [ToolTypes.Settings]: "icon-settings",
  [ToolTypes.Tools]: "icon-tool",
  sheet: "icon-file-outline",
  SHEETS: "icon-file-multiple",
  Open: "icon-external-link",
  Mail: "icon-mail",
  Trash: "icon-trash-2",
  Restore: "icon-rotate-ccw",
  Maximize: "icon-maximize-2",
  Collapse: "icon-minimize-2",
  Edit: "icon-edit-2",
  Cut: "icon-scissors",
  Copy: "icon-copy",
  Duplicate: "icon-Copy-4",
  Paste: "icon-file",
  Plus: "icon-plus",
  Minus: "icon-minus",
  ChevronRight: "icon-chevron-right",
  ChevronLeft: "icon-chevron-left",
  ChevronUp: "icon-chevron-up",
  ChevronDown: "icon-chevron-down",
  Move: "icon-move",
  ArrowRight: "icon-arrow-right",
  Menu: "icon-menu",
  Star: "icon-star",
  Share: "icon-share-2",
  StarFill: "icon-star-3",
  Screenshot: "icon-camera",
  DataView: "icon-process_table",
  ProcessFlow: "icon-sitemap-outline",
  Undo: "icon-undo-variant",
  Redo: "icon-redo-variant",
  FileConfig: "icon-file-cog",
  AddColumn: "icon-playlist-plus",
  RemoveColumn: "icon-playlist-remove",
  AddRow: "icon-table-row-plus-before",
  RemoveRow: "icon-table-row-remove",
  Merge: "icon-table-merge-cells",
  Unmerge: "icon-table-split-cell",
  AddComment: "icon-comment-plus-outline",
  EditComment: "icon-comment-edit-outline",
  DeleteComment: "icon-comment-remove-outline",
  DeleteArrow: "icon-close",
  Palette: "icon-palette-outline",
  CustomStyles: "icon-palette",
  Home: "icon-home",
  Info: "icon-information",
  ArrowDown: "icon-arrow-down-bold-circle",
  Help: "icon-help-circle",
  Alert: "icon-alert-circle",
  Progress: "icon-progress-check",
  AccountReactivate: "icon-account",
  Grid: "icon-grid-2",
  Direction: "icon-directions-fork",
  VerticalDots: "icon-more-vertical",
  Check: "icon-check-circle",
  CheckBold: "icon-check-bold",
  OutlinedCheck: "icon-check-circle-outline",
  OutlinedCircle: "icon-circle-outline",
  OutlinedCircleMinus: "icon-minus-circle-outline",
  // Temporary Number format icons
  General: "icon-set-all",
  Number: "icon-counter",
  Currency: "icon-currency-eur",
  ShortDate: "icon-calendar-clock",
  LongDate: "icon-clipboard-text-clock",
  Time: "icon-clock-time-five-outline",
  Percentage: "icon-percent-outline",
  Fraction: "icon-fraction-one-half",

  Text: "icon-text-2",
  Options: "icon-file-cog",
  Search: "icon-magnify",
  Fill: "icon-basket-fill",
  DownArrow: "icon-arrow-down",
  UpArrow: "icon-arrow-up",
  RightArrow: "icon-arrow-right",
  LeftArrow: "icon-arrow-left",
  Table: "icon-table-plus",
  NameRange: "icon-table_range_A",
  NameManager: "icon-table_range_A",
  TableEdit: "icon-table-edit",
  AlignTop: "icon-align-vertical-top",
  AlignMiddle: "icon-align-vertical-center",
  AlignBottom: "icon-align-vertical-bottom",
  AlignLeft: "icon-format-align-left",
  AlignCenter: "icon-format-align-center",
  AlignRight: "icon-format-align-right",
  CellIcons: "icon-simple-icons",
  Bold: "icon-format-bold",
  ClearStyle: "icon-format-color-marker-cancel",
  FontFace: "icon-format-font",
  Color: "icon-eyedropper-variant",
  BackgroundColor: "icon-format-color-highlight",
  English: "icon-English1",
  Deutsch: "icon-Deutsch1",
  Logout: "icon-logout",
  BusinessDialog: "icon-office-building-cog",
  RedZone: "icon-Red-zone-2",
  GameZone: "icon-Gme-zone-2",
  EditPlayer: "icon-Edit-player-6",
  RenameSheet: "icon-Rename-sheet",
  FontSize: "icon-Font-size",
  Width: "icon-Weight",
  Height: "icon-Height",
  AddPlayer: "icon-Add-player",
  HideRow: "icon-Row-hide-1",
  HideColumn: "icon-Column-hide-1",
  Autolayout: "icon-auto-mode",
  HideLines: "icon-eye-off-outline",
  Lines: "icon-eye-outline",
  FlowArrow: "icon-arrow-right-thin",
  Circle: "icon-circle",
  Descending: "icon-Descending",
  Ascending: "icon-Ascending",
  AddTable: "icon-table-plus",
  ExpandRangeSelection: "icon-Table-5",
  CollapseRangeSelection: "icon-Table-4",
  Filter: "icon-Filter-2",
  FormatPainter: "icon-marker",
  FormulaBox: "icon-Expand",
  BlueZone: "icon-Red-Zone",
  MenuUp: "icon-menu-up",
  MenuDown: "icon-menu-down",
};

const viewIcons = [
  {
    title: "Bag",
    icon: "icon-bag-suitcase",
  },
  {
    title: "Chart",
    icon: "icon-chart-bar",
  },
  {
    title: "Chair",
    icon: "icon-chair-school",
  },
  {
    title: "Ruler",
    icon: "icon-ruler",
  },
  {
    title: "Document",
    icon: "icon-file-document-outline",
  },
  {
    title: "Dollar",
    icon: "icon-currency-usd",
  },
  {
    title: "Euro",
    icon: "icon-currency-eur",
  },
  {
    title: "Filter",
    icon: "icon-Filter-2",
  },
  {
    title: "Airplane",
    icon: "icon-airplane",
  },
  {
    title: "Car",
    icon: "icon-car",
  },
  {
    title: "Toolbox",
    icon: "icon-toolbox-outline",
  },
  {
    title: "Flag",
    icon: "icon-flag-outline",
  },
  {
    title: "Home",
    icon: "icon-home",
  },
];
export { icons, ProcessItemTypes, BlueZoneItemTypes, TeamTypes, ToolTypes, ProcessTypes, viewIcons };
